// API base URL: REACT_APP_API_BASE_URL when set (so `npm start` follows .env); otherwise localhost:6010 on
// localhost, else api.<domain> (admin.example.com -> api.example.com).
const PORTNUMBER = (process.env.REACT_APP_API_BASE_URL
  || (window.location.hostname === "localhost"
    ? "http://localhost:6010"
    : `https://api.${window.location.hostname.replace(/^admin\./, "")}`)
).replace(/\/+$/, "");
const API = {
  PORTNUMBER: `${PORTNUMBER}`,
  LOGIN_API: `${PORTNUMBER}/adminLogin`,
  FORGETPASSWORD_API: `${PORTNUMBER}/forgetPassword`,
  RESETPASSWORD_API: `${PORTNUMBER}/resetPassword`,
  ADMIN_CHANGE_PASSWORD_API: `${PORTNUMBER}/adminChangePassword`,

  // Cookie Policy APIs
  COOKIE_POLICY_GET: `${PORTNUMBER}/api/cookie-policy`,
  COOKIE_POLICY_UPDATE: `${PORTNUMBER}/api/admin/cookie-policy`,
  COOKIE_PREFERENCE: `${PORTNUMBER}/api/user/cookie-preference`,
  PARCEL2GO_DOWNLOAD_LABEL_API: `${PORTNUMBER}/parcel2go/download-label`,
};
export default API;
